import { render, staticRenderFns } from "./CustomerSearchBox.vue?vue&type=template&id=0163f06f"
import script from "./CustomerSearchBox.vue?vue&type=script&lang=js"
export * from "./CustomerSearchBox.vue?vue&type=script&lang=js"
import style0 from "./CustomerSearchBox.vue?vue&type=style&index=0&id=0163f06f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports